export default function Navbar() {
    return (
        <div className="fixed top-0 left-0 text-center w-full header bg-violet-600 py-4 text-white font-bold text-lg shadow-lg">
            Simple Todo Application with RTK Query
        </div>
    );
}
